import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import { REPORT_ROUTE } from '../router/routes';
import { deleteReservation } from '../../actions/reservationActions';
import { setReservationId } from '../../actions/reportActions';

export function Row1({ lotName, reservationDate, reservationId }) {
  const dispatch = useDispatch();

  function removeItem() {
    dispatch(deleteReservation(reservationId)).catch(() => {
      toast.error('Chyba rezervace nemohla být vymazána.');
    });
  }

  function changeReservationId() {
    dispatch(setReservationId(reservationId));
  }

  const items = [
    {
      text: 'Nahlásit',
      action: changeReservationId,
      to: REPORT_ROUTE
    },
    {
      text: 'Zrušit rezervaci',
      action: removeItem,
      to: '#'
    }
  ];

  return (
    <div className="card__header">
      <div className="col-6">
        <i className="fas fa-map-marker-alt" />
        <span className="ml1">{lotName}</span>
      </div>
      <div className="col-6">
        <i className="far fa-calendar" />
        <span className="ml1">{reservationDate}</span>
        <DropdownMenu items={items} />
      </div>
    </div>
  );
}

export function Row2({ timeFrom, timeTo, plateNo }) {
  const reservationTime = `${timeFrom} - ${timeTo}`;
  return (
    <div className="card__row sm-flex">
      <div className="col-6">
        <i className="far fa-address-card" />
        <span className="card__row--label ml1">SPZ</span>
        <span className="ml1">{plateNo}</span>
      </div>
      <div className="col-6">
        <i className="far fa-clock" />
        <span className="card__row--label ml1">Čas</span>
        <span className="ml1">{reservationTime}</span>
      </div>
    </div>
  );
}

export function Row3({ latitude, longitude, floor }) {
  const link = `https://www.google.com/maps/place/${latitude}+${longitude}`;
  return (
    <div className="card__row sm-flex">
      <div className="col-6">
        <i className="fas fa-grip-lines" />
        <span className="card__row--label ml1">Patro</span>
        <span className="ml1">{floor}</span>
      </div>
      <div className="col-6">
        <i className="fas fa-map-pin" />
        <span className="card__row--label ml1">Mapa</span>
        <span className="ml1">
          <a href={link} rel="noopener noreferrer" target="_blank">
            otevřít
          </a>
        </span>
      </div>
    </div>
  );
}

Row1.propTypes = {
  reservation: PropTypes.shape({
    floor: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    lotName: PropTypes.string,
    place: PropTypes.string,
    plateNo: PropTypes.string,
    reservationDate: PropTypes.string,
    reservationId: PropTypes.number,
    timeFrom: PropTypes.string,
    timeTo: PropTypes.string,
    userId: PropTypes.number
  })
};

Row1.defaultProps = {
  reservation: null
};

Row2.propTypes = {
  reservation: PropTypes.shape({
    floor: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    lotName: PropTypes.string,
    place: PropTypes.string,
    plateNo: PropTypes.string,
    reservationDate: PropTypes.string,
    reservationId: PropTypes.number,
    timeFrom: PropTypes.string,
    timeTo: PropTypes.string,
    userId: PropTypes.number
  })
};

Row2.defaultProps = {
  reservation: null
};

Row3.propTypes = {
  reservation: PropTypes.shape({
    floor: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    lotName: PropTypes.string,
    place: PropTypes.string,
    plateNo: PropTypes.string,
    reservationDate: PropTypes.string,
    reservationId: PropTypes.number,
    timeFrom: PropTypes.string,
    timeTo: PropTypes.string,
    userId: PropTypes.number
  })
};

Row3.defaultProps = {
  reservation: null
};
